<template>
  <b-card no-body on-footer class="h-100 book-card" style="min-height: 342px !important">
    <div class="bg-light text-center" style="height: 223px">
      <b-card-img-lazy
        v-if="book.image_url"
        :src="book.image_url"
        alt=""
        top
        style="min-height: 223px; object-fit: cover;"
      ></b-card-img-lazy>
      <div v-else class="d-flex align-items-center justify-content-center" style="min-height: 223px">
        <b-icon-image class="text-muted" font-scale="3"></b-icon-image>
      </div>
    </div>

    <b-card-body class="pb-2 pt-2">
      <p class="mb-1 small book-code">{{ book.book_code }}</p>
      <h6 class="book-title">{{ book.book_name }}</h6>
    </b-card-body>

    <div class="pb-2" style="width: 100%">
      <div class="d-flex align-items-center justify-content-center">
        <b-button
          size="sm"
          variant="outline-primary"
          @click="$emit('edit', book)"
        >
          แก้ไขหนังสือ
        </b-button>
        <b-button
          size="sm"
          variant="outline-danger"
          class="ml-2"
          @click="$emit('delete', book)"
        >
          <b-icon-trash-fill></b-icon-trash-fill>
        </b-button>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "BookCard",
  props: {
    book: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.book-card {
  cursor: default;
  transition: box-shadow 0.2s;
}
.book-card:hover {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}
.book-code {
  line-height: 1.4;
  height: 1.4em;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.book-title {
  line-height: 1.4;
  height: 2.8em;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
